import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import oLocalStorage from '@/services/objectLocalStorage';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import _ from 'lodash';

Vue.use(Vuex);

let langSelected = oLocalStorage.get('langSelected') !== null ? oLocalStorage.get('langSelected') : process.env.LANGUAGES['en-GB'];

if (langSelected) {
  moment.locale(langSelected.lang);
}

let dateFormat = moment()
  .localeData()
  .longDateFormat('L')
  .replace('YYYY', 'yyyy')
  .replace('DD', 'dd');

const state = {
  isLogged: !!localStorage.getItem(keys.tokenKey),
  user: oLocalStorage.get(keys.pmsUserDataKey) !== null ? oLocalStorage.get(keys.pmsUserDataKey) : null,
  apiLocations: process.env.API_LOCATION,
  langs: process.env.LANGUAGES,
  countryConstants: process.env.COUNTRY_CONSTANTS,
  apiSelected: oLocalStorage.get(keys.apiSelected) !== null ? oLocalStorage.get(keys.apiSelected) : process.env.API_LOCATION['es'],
  langSelected: oLocalStorage.get(keys.langSelected) !== null ? oLocalStorage.get(keys.langSelected) : process.env.LANGUAGES['en-GB'],
  countryConstantsSelected: oLocalStorage.get(keys.countryConstantsSelected) !== null ? oLocalStorage.get(keys.countryConstantsSelected) : process.env.COUNTRY_CONSTANTS['es'],
  token: oLocalStorage.get(keys.tokenKey) !== null ? oLocalStorage.get(keys.tokenKey) : null,
  dateFormat: dateFormat,
  dateFormatTime: `${dateFormat} 'HH:mm'`,
  parkingList: oLocalStorage.get(keys.parkingList) !== null ? oLocalStorage.get(keys.parkingList) : [],
  parkingSelected: oLocalStorage.get(keys.parkingSelected) !== null ? oLocalStorage.get(keys.parkingSelected) : null,
  parkingSpots: [],
  parkingTotalSpots: 0,
  headquarters: process.env.HEADQUARTERS,
  partnersLinks: process.env.PARTNERS_LINKS,
  investorsLinks: process.env.INVESTORS_LINKS,
  mediaLinks: process.env.MEDIA_LINKS,
  spanishCountries: process.env.SPANISH_COUNTRIES,
  ogUrlHost: process.env.OG_URL_HOST
};

const mutations = {
  LOGIN_USER(state, user) {
    let lang = _.find(state.langs, itLang => {
      return itLang.langWsp === user.manager.locale;
    });
    user.manager.localeIso = lang.langIso;

    state.isLogged = true;
    state.user = user;
    oLocalStorage.set(keys.pmsUserDataKey, user);
  },

  UPDATE_TOKEN(state, token) {
    token.expirationDate = moment()
      .add(token.expires_in, 'seconds')
      .toDate();
    state.token = token;
    oLocalStorage.set(keys.tokenKey, token);
  },

  LOGOUT_USER(state) {
    state.isLogged = false;
    state.user = null;
    state.token = null;
    state.parkingList = [];
    state.parkingSelected = null;
    oLocalStorage.remove(keys.tokenKey);
    oLocalStorage.remove(keys.pmsUserDataKey);
    oLocalStorage.remove(keys.parkingList);
    oLocalStorage.remove(keys.parkingSelected);
  },

  CHANGE_API_SELECTED(state, apiSelected) {
    state.apiSelected = state.apiLocations[apiSelected];
    state.countryConstantsSelected = state.countryConstants[state.apiSelected.code];

    oLocalStorage.set(keys.apiSelected, state.apiSelected);
    oLocalStorage.set(keys.countryConstantsSelected, state.countryConstantsSelected);

    EventBus.$emit(keys.eventOnApiSelected, {});
  },

  UPDATE_COUNTRY_CONSTANTS(state, data) {
    state.countryConstantsSelected = state.countryConstants[state.apiSelected.code];
    oLocalStorage.set(keys.countryConstantsSelected, state.countryConstantsSelected);
  },

  // CHANGE_LANG_SELECTED(state, langSelected) {
  //   state.langSelected = state.langs[langSelected];
  //   oLocalStorage.set(keys.langSelected, state.langSelected);

  //   moment.locale(state.langSelected.lang);
  //   state.dateFormat = moment()
  //     .localeData()
  //     .longDateFormat('L')
  //     .replace('YYYY', 'yyyy')
  //     .replace('DD', 'dd');
  //   state.dateFormatTime = `${state.dateFormat} HH:mm`;

  //   EventBus.$emit(keys.eventOnLanguageChanged);
  // },

  CHANGE_LANG_SELECTED(state, params) {
    let langSelected = params.langSelected;
    state.langSelected = state.langs[langSelected];
    oLocalStorage.set(keys.langSelected, state.langSelected);

    moment.locale(state.langSelected.lang);
    state.dateFormat = moment()
      .localeData()
      .longDateFormat('L')
      .replace('YYYY', 'yyyy')
      .replace('DD', 'dd');
    state.dateFormatTime = `${state.dateFormat} HH:mm`;

    if (!params.init) {
      EventBus.$emit(keys.eventOnLanguageChanged);
    }
  },

  UPDATE_PARKING_LIST(state, parkingList) {
    state.parkingList = parkingList;
    oLocalStorage.set(keys.parkingList, parkingList);
  },

  UPDATE_PARKING_SELECTED(state, parking) {
    state.parkingSelected = parking;
    oLocalStorage.set(keys.parkingSelected, parking);
    EventBus.$emit(keys.eventOnParkingSelected, {
      parking: parking
    });
  },

  UPDATE_PARKING_SPOTS(state, spots) {
    state.parkingSpots = spots;
    state.parkingTotalSpots = spots.length;
  },

  UPDATE_PARKING_SPOTS_TOTAL(state, total) {
    state.parkingTotalSpots = total;
  },

  ON_WINDOWS_RESIZE(state, params) {
    EventBus.$emit(keys.eventOnScreenSizeChanged, params);
  }
};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  keys,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js